module.exports = __webpack_public_path__ + "static/images/59130ab3defdeab82ab597ba6569d70a.png";